import React from 'react';

const TogglePlan = ({ selected, setSelected, pricingOptions }) => {
  return (
    <div className="relative flex w-fit rounded-[12px] bg-white/10 p-1 text-center ring-1 ring-inset ring-white/10">
      {pricingOptions.map((list, index) => {
        return (
          <React.Fragment key={index}>
            <button
              type="button"
              aria-pressed={selected.val === list.val}
              className={`flex min-w-[160px] cursor-pointer justify-center rounded-[9px] px-4 py-2.5 text-[13px] font-bold transition-colors max_md:min-w-[145px] max_sm:min-w-0 max_sm:px-3 max_sm:text-[11px] ${
                selected.val === list.val
                  ? 'bg-white text-LightPrimary'
                  : 'text-white/60 hover:text-white'
              }`}
              onClick={() => setSelected(list)}
            >
              {list.name}
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TogglePlan;
